/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class KpiReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getKpiSummary({ from, to }) {
    return axios.get(`${this.url}/kpi_summary`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  downloadKpiExport({ from, to }) {
    return axios.get(`${this.url}/kpi_export`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimeOffset(),
      },
      responseType: 'blob',
    });
  }
}

export default new KpiReportsAPI();
